import { create } from 'zustand';
import { persist } from 'zustand/middleware';
// Environments the operator can target at runtime from the login screen.
// 'dev' is the working backend; 'prod' is a placeholder until a real prod API exists.
export const SELECTABLE_ENVS = ['prod', 'dev'];
export const useEnvironmentStore = create()(persist((set) => ({
    env: 'dev',
    setEnv: (env) => set({ env }),
}), { name: 'admin-environment' }));
